import branding from '../../config/branding';

export const DEVELOPMENT_MODE = process.env.NODE_ENV !== 'production';

export const API_ENDPOINT = `https://api.${branding.domain}/api`;
export const AKAMAI_ENDPOINT = `https://${branding.cdnDomain}/`;
export const SOCKET_ENDPOINT = `https://api.${branding.domain}`;

export const GetHeaders = async (token?: string | boolean) => {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return { headers };
};

export const ServerFetch = async (
  url: string,
  options: RequestInit,
  authenticated?: string | boolean,
) => {
  const { headers } = await GetHeaders(authenticated);
  try {
    const response = await fetch(url, { ...options, headers });
    // Interceptar 401 Unauthorized - sessão expirada
    if (response.status === 401) {
      console.warn('ServerFetch: 401 Unauthorized', url);
      return { error: true, status: 401, message: 'Unauthorized' };
    }
    try {
      return await response.json();
    } catch (err) {
      console.log('ServerParseError', err, url, { ...options, headers });
      return response;
    }
  } catch (error) {
    console.log('ServerFetchError', error);
    return false;
  }
};

export const GET = async (path: string, authenticated: string | boolean = false) => {
  return await ServerFetch(
    `${API_ENDPOINT}${path}`,
    {
      method: 'GET',
    },
    authenticated,
  );
};

export const POST = async (
  path: string,
  body: unknown,
  authenticated: string | boolean = false,
) => {
  return await ServerFetch(
    `${API_ENDPOINT}${path}`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
    authenticated,
  );
};

export const PUT = async (path: string, body: unknown, authenticated: string | boolean = false) => {
  return await ServerFetch(
    `${API_ENDPOINT}${path}`,
    {
      method: 'PUT',
      body: JSON.stringify(body),
    },
    authenticated,
  );
};

export const DELETE = async (path: string, authenticated: string | boolean = false) => {
  return await ServerFetch(
    `${API_ENDPOINT}${path}`,
    {
      method: 'DELETE',
    },
    authenticated,
  );
};

export const ReadAddressesByZipCode = async (zipCode: string) => {
  try {
    const result = await fetch(`https://viacep.com.br/ws/${zipCode}/json/`);
    return result.json();
  } catch (err) {
    return false;
  }
};

export const ResolveUri = (result: Record<string, unknown> | string | null) => {
  const path = result?.path
    ? result?.path
    : result?.fileCopyUri
      ? result?.fileCopyUri
      : result?.uri
        ? result?.uri
        : result?.croppedImage
          ? result?.croppedImage
          : typeof result === 'string'
            ? result
            : null;
  return path?.indexOf('file://') === -1 ? `file://${path}` : path;
};

export const PrepareFile = (result: Record<string, unknown> | string | null) => {
  const uri = ResolveUri(result);
  const name = uri.split('/').pop();
  const match = /\.(\w+)$/.exec(name);
  const type = match ? `image/${match[1]}` : `image`;
  return { uri, name, type };
};

export const ServerUploadImage = async (result: Record<string, unknown> | string | null) => {
  return await PostImage(PrepareFile(result));
};

export const PostImage = async (fileToUpload: { uri: string; name: string; type: string }) => {
  const formData = new FormData();
  formData.append('files', fileToUpload, fileToUpload.name);
  const { headers } = await GetHeaders(true);
  delete headers['Content-Type'];
  const response = await fetch(`${API_ENDPOINT}/upload`, {
    method: 'POST',
    body: formData,
    headers,
  });
  const responseJson = await response.json();
  return responseJson?.[0];
};
